export default __webpack_public_path__ + "static/media/omg-excited.f0f85782.gif";